import React from 'react'
import Colors from 'utils/Colors'
import styles from './styles'

/** Requires parent component style to be position: relative to adjust. */
const NotificationIcon = ({
  children,
  color = Colors.white,
  backgroundColor = Colors.red,
  borderColor = undefined,
  style = {},
  topPosition = undefined,
  rightPosition = undefined,
  bottomPosition = undefined,
  leftPosition = undefined,
}) => {
  const classes = styles()
  const border = borderColor ? `1px solid ${borderColor}` : undefined
  return (
    <div
      className={classes.notification}
      style={{
        color,
        border,
        backgroundColor,
        top: topPosition,
        right: rightPosition,
        left: leftPosition,
        bottom: bottomPosition,
        ...style,
      }}
    >
      {children}
    </div>
  )
}

export default NotificationIcon
